// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__VWpKw","calendarButtons":"ClockData_calendarButtons__UPDvd"};